import { render, staticRenderFns } from "./MaskList.vue?vue&type=template&id=6467a87c&scoped=true&"
import script from "./MaskList.vue?vue&type=script&lang=js&"
export * from "./MaskList.vue?vue&type=script&lang=js&"
import style0 from "./MaskList.vue?vue&type=style&index=0&id=6467a87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467a87c",
  null
  
)

export default component.exports